module.exports = __webpack_public_path__ + "img/ColorsStyle.91721e85.svg";